import { ProgressBar as AriaProgressBar } from 'react-aria-components'

import styles from './ProgressBar.module.css'
import cx from '@/utils/classnames'

interface ProgressBarProps {
  progress: number
  'aria-label'?: string
  'aria-labelledby'?: string
  testId?: string
}

/**
 * The ProgressBar
 */
export function ProgressBar({ progress, testId, ...rest }: ProgressBarProps) {
  return (
    <AriaProgressBar
      data-test={testId}
      {...rest}
      className={styles.progress}
      value={progress}
      maxValue={100}
    >
      <div
        className={cx(styles.progressBar)}
        style={{ transform: `translateX(${progress - 100}%)` }}
      />
    </AriaProgressBar>
  )
}
